import type { QuoteFile } from 'paintscout'

/**
 * We use s3PublicKey/cloudinaryPublicId as the key since we don't want the same picture in the
 * library twice. A file has exactly one of the two set (see docs/flows/media-file-pipeline.md),
 * so s3PublicKey is preferred and cloudinaryPublicId is the fallback for files that predate S3
 * uploads (e.g. video/pdf, which stay on Cloudinary).
 */
export const getLibraryFileKey = (file: QuoteFile) => file?.s3PublicKey || file?.cloudinaryPublicId
